import React, { memo, useCallback, useMemo } from "react";
import { NodeProps } from "reactflow";
import { NodeData, NodeType } from "../../../models/nodeType";
import { useForm } from "react-hook-form";
import { FormControl, FormLabel, Input, Text } from "@chakra-ui/react";
import { FlowNodeWithChildren } from "./FlowNode";
import { useUpdateNodeData } from "../../../hooks/useUpdateNodeData";
import { clampToPositiveNonZeroNumber } from "../../../utils/clampToPositiveNonZeroNumber";

interface FormData extends NodeData {
  zoom: number;
}

const CameraSnapToLocationNode: React.FC<NodeProps<NodeType<FormData>>> = (props) => {
  const {
    id: nodeId,
    data: { color, nodeData },
  } = props;

  const zoom = nodeData?.zoom ?? 1;

  const { register, setValue, handleSubmit } = useForm<FormData>({
    defaultValues: useMemo(
      () => ({
        zoom,
      }),
      [zoom]
    ),
    mode: "onBlur",
  });

  const { updateNodeData } = useUpdateNodeData<FormData>(nodeId);

  const handleUpdate = useCallback(
    ({ zoom }: FormData) => {
      const clampedZoom = clampToPositiveNonZeroNumber(zoom);

      updateNodeData({
        zoom: clampedZoom,
      });

      setValue("zoom", clampedZoom);
    },
    [updateNodeData, setValue]
  );

  return (
    <FlowNodeWithChildren {...props}>
      <form className={"nodrag"} onSubmit={handleSubmit(handleUpdate)} onBlur={handleSubmit(handleUpdate)}>
        <FormControl>
          <FormLabel>
            <Text casing={"uppercase"} color={color}>
              Zoom
            </Text>
          </FormLabel>
          <Input {...register("zoom", { valueAsNumber: true })} color={color} />
        </FormControl>
      </form>
    </FlowNodeWithChildren>
  );
};

export default memo(CameraSnapToLocationNode);
